var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"total":_vm.total,"table-data":_vm.tableData,"table-config":_vm.tableConfig,"has-back":""},on:{"onChangePage":_vm.changeCurrentPage,"onHandle":_vm.tableHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }